import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import { ROLL_CALL_API_BASE_URL } from "../RollCallConfig/RollCallConfig";
import { Select } from "antd";

const EditRegistration = ({ editObj }) => {
  const [editObjData, setEditObjData] = useState({});
  const [branchesData, setBranchesData] = useState([]);
  const [deptData, setDeptData] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  useEffect(() => {
    if (editObj) {
      setEditObjData(editObj);
    }
  }, [editObj]);

  console.log(editObjData);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchBranches = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch branches");
          }

          const data = await response.json();

          if (data && data.status === true && Array.isArray(data.ResultData)) {
            setBranchesData(data.ResultData);
          } else {
            console.error("Invalid branch response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching branches:", error.message);
        }
      };

      fetchBranches();
    }
  }, [tokenData, superIdData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchDepartments = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/department/getdepartment?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch departments");
          }

          const data = await response.json();

          if (data && data.status === true && Array.isArray(data.ResultData)) {
            setDeptData(data.ResultData);
          } else {
            console.error("Invalid department response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching departments:", error.message);
        }
      };

      fetchDepartments();
    }
  }, [tokenData, superIdData]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditObjData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDepartmentChange = (selectedDepartmentId) => {
    setEditObjData((prevData) => ({
      ...prevData,
      Departmentid: selectedDepartmentId,
    }));
  };

  const handleBranchChange = (selectedBranchId) => {
    setEditObjData((prevData) => ({
      ...prevData,
      BranchId: selectedBranchId,
    }));
  };

  const branchOptions =
    branchesData &&
    branchesData.map((item) => ({
      value: item.branchid,
      label: item.Name,
    }));

  const departmentOptions =
    deptData &&
    deptData.map((item) => ({
      value: item.departmentid,
      label: item.Name,
    }));

  const handleUpdateRegistration = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    const requestBody = {
      superid: superIdData,
      badge: editObjData.Badge,
      username: editObjData.UserName,
      dateofbirth: editObjData.DateOfBirth,
      designation: editObjData.Designation,
      cardid: editObjData.CardId,
      mobile: editObjData.Mobile,
      rfid: editObjData.RFID,
      gender: editObjData.Gender,
      branchid: editObjData.BranchId,
      departmentid: editObjData.Departmentid,
      doj: editObjData.DateOfJoining,
      regid: editObjData.regid,
    };
    try {
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/emp/updateEmployee`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
          body: JSON.stringify(requestBody),
        }
      );

      const responseData = await response.json();

      if (responseData.status) {
        Swal.fire({
          title: "Success",
          text: responseData.Message || "Employee updated successfully",
          icon: "success",
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          title: "Error",
          text: responseData.Message || "Failed to update employee.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error updating employee:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to update employee due to network or server error.",
        icon: "error",
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <div>
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasRightEditReg {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightEditReg {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightEditReg {
            width: 40% !important;
          }
        }
          
       @media (min-width: 1441px) and (max-width:2550px) {
          #offcanvasRightEditReg {
            width: 28% !important;
          }
        }
        @media (min-width:2551px) {
          #offcanvasRightEditReg {
            width:20% !important;
          }
        }
        `}
      </style>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightEditReg"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Edit Registration</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr className="m-0 p-0" />
        <div className="offcanvas-body">
          <form onSubmit={handleUpdateRegistration}>
            <div className="content">
              <div className="row">
                {[
                  { label: "Name", name: "UserName", type: "text" },
                  { label: "Emp ID", name: "Badge", type: "text" },
                  { label: "Biometric", name: "CardId", type: "text" },
                  { label: "Mobile", name: "Mobile", type: "text" },
                  { label: "DOB", name: "DateOfBirth", type: "date" },
                  { label: "DOJ", name: "DateOfJoining", type: "date" },
                  { label: "Designation", name: "Designation", type: "text" },
                  { label: "RFID", name: "RFID", type: "text" },
                ].map((input) => (
                  <div key={input.name} className="col-6">
                    <label className="form-label">{input.label}</label>
                    {/* <input type={input.type} className="form-control" name={input.name} value={editObjData[input.name] || ""} onChange={handleInputChange} /> */}
                    <input
                      type={input.type}
                      className="form-control"
                      name={input.name}
                      value={
                        input.type === "date" && editObjData[input.name]
                          ? new Date(editObjData[input.name])
                              .toISOString()
                              .split("T")[0]
                          : editObjData[input.name] || ""
                      }
                      onChange={handleInputChange}
                    />
                  </div>
                ))}
                <div className="col-6">
                  <label className="form-label">Gender</label>
                  <select
                    className="form-select"
                    name="Gender"
                    value={editObjData?.Gender?.toString() || ""}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="" disabled>
                      Select Gender
                    </option>
                    <option value="1">Male</option>
                    <option value="0">Female</option>
                  </select>
                </div>
                <div className="col-6">
                  <label className="form-label">Department</label>
                  <Select
                    showSearch
                    placeholder="Choose Department"
                    value={editObjData.Departmentid || null}
                    onChange={handleDepartmentChange}
                    options={departmentOptions}
                    style={{ width: "100%" }}
                  />
                </div>

                <div className="col-6 d-none">
                  <label className="form-label">Branch</label>
                  <Select
                    showSearch
                    placeholder="Choose Branch"
                    value={Number(editObjData.BranchId) || null}
                    onChange={handleBranchChange}
                    options={branchOptions}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end mt-3">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={submitLoading}
                >
                  {submitLoading ? "Updating..." : "Submit"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

EditRegistration.propTypes = {
  editObj: PropTypes.object.isRequired,
};

export default EditRegistration;
